module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pback8-68582b653579b3a30d90574d8af39369.jpg";